import { FC } from 'react';

import { Sega } from '@features/Sega';

export const Home: FC = () => <Sega />;
